"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5270],{

/***/ 59040:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/isielBySomZnovaNaVysoku.1a1d3d9c.jpg","height":360,"width":640,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAfEAABBAICAwAAAAAAAAAAAAABAAIFEQMEBhIiYYH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABYRAQEBAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8Al8kl5KMi8GbW2uhOcuprevkBYcPdWPqIiTFf/9k=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 55270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_NavBar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(70638);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(15714);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(60071);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(81990);
// EXTERNAL MODULE: ./src/components/core/Flex.tsx
var Flex = __webpack_require__(90656);
// EXTERNAL MODULE: ./src/components/core/Text.tsx
var Text = __webpack_require__(43195);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(72444);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(34376);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(37559);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dropdown-menu/dist/index.module.js + 37 modules
var index_module = __webpack_require__(57138);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(12691);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/AuthUserContext.tsx
var AuthUserContext = __webpack_require__(92232);
// EXTERNAL MODULE: ./src/QueryGuard.tsx
var QueryGuard = __webpack_require__(10229);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(80371);
// EXTERNAL MODULE: ./src/api/user.ts
var api_user = __webpack_require__(12874);
// EXTERNAL MODULE: ./src/components/core/Button.tsx
var Button = __webpack_require__(21523);
// EXTERNAL MODULE: ./src/components/core/NextLink.tsx
var NextLink = __webpack_require__(96791);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(9507);
// EXTERNAL MODULE: ./src/components/domain/user/UserAvatar.tsx
var UserAvatar = __webpack_require__(99990);
;// CONCATENATED MODULE: ./src/components/domain/buttons/LogInOrOutButton.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    cursor: pointer;\n    opacity: 0.9;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  all: unset;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--color-primary);\n  border-radius: 12px;\n  padding: 12px 15px;\n  border: 1px solid var(--color-secondary);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block !important;\n  all: unset;\n  white-space: nowrap;\n  color: var(--color-secondary);\n  margin: 12px 0;\n\n  &:focus,\n  &:hover {\n    color: var(--color-accent);\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: var(--color-secondary);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}














var LogInOrOutButton = function() {
    var ref = (0,AuthUserContext/* useAuth */.a)(), user = ref.user, isLoading = ref.isLoading, logout = ref.logout;
    var router = (0,next_router.useRouter)();
    var useGetSocUser = (0,api_user/* useGetUser */.pg)(!isLoading) // call when ready
    ;
    if (isLoading) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* default */.Z, {});
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QueryGuard/* QueryGuard */.l, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useGetSocUser), {
            children: function(socUser) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        (!user || !socUser) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                            href: routes/* routes.login.redirectUri */._.login.redirectUri(encodeURIComponent(router.asPath)),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                children: "Prihl\xe1siť"
                            })
                        }),
                        user && socUser && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_module/* Root */.fC, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Trigger, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledUserAvatar, {
                                        src: socUser.imageUrl || "",
                                        name: socUser.name,
                                        sizePx: 40
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContent, {
                                    sideOffset: 2,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: routes/* routes.profil */._.profil,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropDownItem, {
                                                children: "Moje kurzy a nastavenia"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropDownItem, {
                                            onClick: logout,
                                            children: "Odhl\xe1siť"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropwDownMenuArrow, {})
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }))
    });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f7616881-0"
})(_templateObject());
var StyledUserAvatar = (0,styled_components_browser_esm/* default */.ZP)(UserAvatar/* default */.Z).withConfig({
    componentId: "sc-f7616881-1"
})(_templateObject1());
var Trigger = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Trigger */.xz).withConfig({
    componentId: "sc-f7616881-2"
})(_templateObject2());
var StyledContent = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Content */.VY).withConfig({
    componentId: "sc-f7616881-3"
})(_templateObject3());
var DropDownItem = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Item */.ck).withConfig({
    componentId: "sc-f7616881-4"
})(_templateObject4());
var DropwDownMenuArrow = (0,styled_components_browser_esm/* default */.ZP)(index_module/* Arrow */.Eh).withConfig({
    componentId: "sc-f7616881-5"
})(_templateObject5());
/* harmony default export */ var buttons_LogInOrOutButton = (LogInOrOutButton);

// EXTERNAL MODULE: ./src/theme/device.ts
var device = __webpack_require__(40592);
// EXTERNAL MODULE: ./src/theme/ThemeSwitcher.tsx
var ThemeSwitcher = __webpack_require__(38434);
// EXTERNAL MODULE: ./src/images.tsx + 14 modules
var src_images = __webpack_require__(91195);
;// CONCATENATED MODULE: ./src/components/NavBar.tsx

function NavBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  padding: 24px 32px;\n  width: clamp(320px, 100%, 1200px);\n  position: relative;\n\n  @media ",
        " {\n    max-width: 900px;\n  }\n\n  @media ",
        " {\n    background-color: ",
        ";\n    width: ",
        ";\n  }\n\n  @media ",
        " {\n    padding: 24px 24px;\n  }\n"
    ]);
    NavBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 64px;\n\n  a {\n    text-decoration: none;\n    color: unset;\n  }\n\n  @media ",
        " {\n    gap: 32px;\n  }\n"
    ]);
    NavBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavBar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  white-space: nowrap;\n"
    ]);
    NavBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavBar_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  a {\n    text-decoration: none;\n    color: unset;\n  }\n\n  span {\n    text-align: center;\n  }\n"
    ]);
    NavBar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NavBar_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  width: 24px;\n  height: 24px;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  @media ",
        " {\n    display: block;\n  }\n\n  color: var(--color-secondary);\n"
    ]);
    NavBar_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NavBar_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NavBar_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: ",
        ";\n    align-items: flex-start;\n    position: absolute;\n    padding: 24px 32px;\n    top: 95px;\n    width: 100vw;\n    height: 100vh;\n    left: 0;\n    z-index: 1;\n    background-color: var(--color-primary);\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  aspect-ratio: 3 / 1;\n  height: 60px;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  @media ",
        " {\n    margin-left: -48px;\n  }\n\n  @media ",
        " {\n    margin-left: -48px;\n  }\n\n  @media ",
        " {\n    margin-left: 0px;\n  }\n\n  @media ",
        " {\n    margin-left: 0;\n  }\n\n  @media ",
        " {\n    margin-left: -16px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    cursor: pointer;\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: 0 auto;\n\n  &:hover {\n    cursor: pointer;\n    opacity: 0.7;\n  }\n\n  svg {\n    width: 18px;\n    height: 18px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  [theme-type='DARK'] & {\n    filter: invert(100%);\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}















var NavBar = function() {
    var ref = (0,react.useState)(false), mobileNavbarOpen = ref[0], setMobileNavbarOpen = ref[1];
    var router = (0,next_router.useRouter)();
    var ref1 = (0,AuthUserContext/* useAuth */.a)(), user = ref1.user, logout = ref1.logout;
    var MobileNavbarOptions = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileNavbarOptionsFlex, {
            gap: "24px",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThemeSwitcher/* default */.Z, {}),
                !mobileNavbarOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpenMenuIcon, {
                    onClick: function() {
                        return setMobileNavbarOpen(!mobileNavbarOpen);
                    }
                }),
                mobileNavbarOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseMenuIcon, {
                    onClick: function() {
                        return setMobileNavbarOpen(!mobileNavbarOpen);
                    }
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WrapperFlex, {
        alignSelf: "center",
        justifyContent: "space-between",
        mobileNavbarOpen: mobileNavbarOpen,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoImage, {
                    layout: "fill",
                    alt: "Logo",
                    src: src_images/* socLogo */.NV,
                    onClick: function() {
                        return router.push(routes/* routes.root */._.root);
                    },
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavbarOptions, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuFlex, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuItems, {
                        justifyContent: "center",
                        gap: "48px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThemeSwitcher/* default */.Z, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                styleIfActive: true,
                                href: routes/* routes.kurzy.index */._.kurzy.index,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItemText, {
                                    children: "kurzy"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                styleIfActive: true,
                                href: routes/* routes.podcast.index */._.podcast.index,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItemText, {
                                    children: "podcast"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                styleIfActive: true,
                                href: routes/* routes.clanky.index */._.clanky.index,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItemText, {
                                    children: "čl\xe1nky"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                styleIfActive: true,
                                href: routes/* routes.videa.index */._.videa.index,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItemText, {
                                    children: "vide\xe1"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                styleIfActive: true,
                                href: routes/* routes.oProjekte */._.oProjekte,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItemText, {
                                    children: "o projekte"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttons_LogInOrOutButton, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMenuFlex, {
                open: mobileNavbarOpen,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileMenuItems, {
                    direction: "column",
                    alignItems: "stretch",
                    gap: "32px",
                    children: [
                        !user && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                                href: routes/* routes.login.redirectUri */._.login.redirectUri(encodeURIComponent(router.asPath)),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                    children: "Prihl\xe1siť"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                            styleIfActive: true,
                            href: routes/* routes.kurzy.index */._.kurzy.index,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                children: "Kurzy"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                            styleIfActive: true,
                            href: routes/* routes.podcast.index */._.podcast.index,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                children: "Podcast"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                            styleIfActive: true,
                            href: routes/* routes.clanky.index */._.clanky.index,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                children: "Čl\xe1nky"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                            styleIfActive: true,
                            href: routes/* routes.videa.index */._.videa.index,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                children: "Vide\xe1"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                            styleIfActive: true,
                            href: routes/* routes.oProjekte */._.oProjekte,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                children: "O projekte"
                            })
                        }),
                        user && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextLink/* default */.Z, {
                            styleIfActive: true,
                            href: routes/* routes.profil */._.profil,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                children: "Moje kurzy a nastavenia"
                            })
                        }),
                        user && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoutText, {
                            onClick: logout,
                            children: "Odhl\xe1siť"
                        }),
                        mobileNavbarOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CloseMobileMenuFlexWrapper, {
                            gap: "12px",
                            justifyContent: "center",
                            onClick: function() {
                                return setMobileNavbarOpen(!mobileNavbarOpen);
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseMenuIcon, {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                    children: "Zavrieť"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var WrapperFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4a8fa1b9-0"
})(NavBar_templateObject(), device/* device.L */.U.L, device/* device.M */.U.M, function(props) {
    return props.mobileNavbarOpen && "var(--color-primary)";
}, function(props) {
    return props.mobileNavbarOpen && "100vw";
}, device/* device.XS */.U.XS);
var MenuItems = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4a8fa1b9-1"
})(NavBar_templateObject1(), device/* device.L */.U.L);
var MenuItemText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-4a8fa1b9-2"
})(NavBar_templateObject2());
var MobileMenuItems = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4a8fa1b9-3"
})(NavBar_templateObject3());
var menuIconStyle = (0,styled_components_browser_esm/* css */.iv)(NavBar_templateObject4(), device/* device.M */.U.M);
var OpenMenuIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* AiOutlineMenu */.qTj).withConfig({
    componentId: "sc-4a8fa1b9-4"
})(NavBar_templateObject5(), menuIconStyle);
var CloseMenuIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* AiOutlineClose */.oHP).withConfig({
    componentId: "sc-4a8fa1b9-5"
})(_templateObject6(), menuIconStyle);
var MobileNavbarOptionsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4a8fa1b9-6"
})(_templateObject7(), device/* device.M */.U.M);
var MenuFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4a8fa1b9-7"
})(_templateObject8(), device/* device.M */.U.M);
var MobileMenuFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4a8fa1b9-8"
})(_templateObject9(), device/* device.M */.U.M, function(props) {
    return props.open ? "flex" : "none";
});
var LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a8fa1b9-9"
})(_templateObject10(), device/* device.XL */.U.XL, device/* device.L */.U.L, device/* device.M */.U.M, device/* device.S */.U.S, device/* device.XS */.U.XS);
var LogoutText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-4a8fa1b9-10"
})(_templateObject11());
var CloseMobileMenuFlexWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4a8fa1b9-11"
})(_templateObject12());
var LogoImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
    componentId: "sc-4a8fa1b9-12"
})(_templateObject13());
/* harmony default export */ var components_NavBar = (NavBar);


/***/ }),

/***/ 72463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60071);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81990);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/***
 * Avatar is circle shaped image
 */ var Avatar = function(param) {
    var className = param.className, altName = param.altName, src = param.src, sizePx = param.sizePx, placeholder = param.placeholder;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledAvatar, {
        className: className,
        loading: "eager",
        priority: true,
        alt: altName,
        src: src,
        width: sizePx,
        height: sizePx,
        placeholder: placeholder ? "blur" : undefined
    });
};
var StyledAvatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_2___default())).withConfig({
    componentId: "sc-20a3624b-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ }),

/***/ 99990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81990);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10447);
/* harmony import */ var _core_Avatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72463);
/* harmony import */ var _core_Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90656);
/* harmony import */ var _core_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43195);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n  border: 2px solid var(--color-secondary); // TODO this is probably not working\n  margin: 0 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







// If user has imageUrl then creates circle shaped avatar from image
// otherwise create circle shaped initials
var UserAvatar = function(param) {
    var className = param.className, src = param.src, priority = param.priority, name = param.name, sizePx = param.sizePx, placeholder = param.placeholder;
    if (src) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_core_Avatar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: className,
            src: src,
            altName: name,
            sizePx: sizePx,
            priority: priority,
            placeholder: placeholder
        });
    } else {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(InitialsAvatar, {
            className: className,
            alignItems: "center",
            justifyContent: "center",
            sizePx: sizePx,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_core_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .createAvatarName */ .Gg)(name)
            })
        });
    }
};
var InitialsAvatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_core_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7ae305da-0"
})(_templateObject(), function(props) {
    return "".concat(props.sizePx, "px");
}, function(props) {
    return "".concat(props.sizePx, "px");
});
/* harmony default export */ __webpack_exports__["Z"] = (UserAvatar);


/***/ }),

/***/ 91195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q9": function() { return /* binding */ FirstDesignCourseDetail; },
  "Q5": function() { return /* binding */ FirstDesignHome; },
  "_T": function() { return /* binding */ FirstDesignTakeCoursePage; },
  "gl": function() { return /* binding */ FirstPodcast; },
  "PC": function() { return /* binding */ Gabriel; },
  "Z7": function() { return /* binding */ Jakub; },
  "FA": function() { return /* binding */ ProjectMockup; },
  "KM": function() { return /* binding */ javaCourseLogo; },
  "A2": function() { return /* binding */ images_pavol; },
  "WM": function() { return /* binding */ socLamp; },
  "NV": function() { return /* binding */ socLogo; },
  "Uj": function() { return /* binding */ sqlLogoImage; },
  "rZ": function() { return /* binding */ images_theodor; },
  "X2": function() { return /* binding */ images_webGamesLogo; }
});

;// CONCATENATED MODULE: ./public/images/Course-Detail.jpg
/* harmony default export */ var Course_Detail = ({"src":"/_next/static/media/Course-Detail.abd63d26.jpg","height":645,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAABBAMBAAAAAAAAAAAAAAABAAIDBBESIZH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8ArdurDaijryh+ge1w0kcw5ByOgjxERB//2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/gabriel.jpg
/* harmony default export */ var gabriel = ({"src":"/_next/static/media/gabriel.ff826b62.jpg","height":460,"width":460,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAfEAABBAEFAQAAAAAAAAAAAAACAAEDBBEFBhIhYYH/xAAVAQEBAAAAAAAAAAAAAAAAAAACBf/EABkRAAMAAwAAAAAAAAAAAAAAAAABAgMTUf/aAAwDAQACEQMRAD8AuLVnvboO2ZxzPHWaNoAJ+PzvHuURFP20g1lfD//Z","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/Home.jpg
/* harmony default export */ var Home = ({"src":"/_next/static/media/Home.0c024cb5.jpg","height":540,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAABBQEBAQAAAAAAAAAAAAABAAIDBBExEhP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8ArEVP5zjbVl4bh8vkBB70YiIg/9k=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./public/images/isielBySomZnovaNaVysoku.jpg
var isielBySomZnovaNaVysoku = __webpack_require__(59040);
;// CONCATENATED MODULE: ./public/images/jakub.jpg
/* harmony default export */ var jakub = ({"src":"/_next/static/media/jakub.f20cc6dc.jpg","height":600,"width":600,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAACAgICAwAAAAAAAAAAAAACAwABBBEFEiExkf/EABUBAQEAAAAAAAAAAAAAAAAAAAAD/8QAGBEAAgMAAAAAAAAAAAAAAAAAAQMAAhH/2gAMAwEAAhEDEQA/AJsDCQnhsImgVtakHrJdUBXZavfb34+RESyUUzYY6xIn/9k=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/leto-2020_EDITED.jpg
/* harmony default export */ var leto_2020_EDITED = ({"src":"/_next/static/media/leto-2020_EDITED.341cda41.jpg","height":1239,"width":872,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAYDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAABBAIDAAAAAAAAAAAAAAAAAQIDIQQRBRPx/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAVEQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEQMRAD8Aoszjsd0Ea9LXqmtUlV4ACiRL/9k=","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/prvy_podcast-scaled.jpg
/* harmony default export */ var prvy_podcast_scaled = ({"src":"/_next/static/media/prvy_podcast-scaled.664b4b98.jpg","height":791,"width":1280,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAbEAACAwADAAAAAAAAAAAAAAABAgADEQUhQf/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAYEQADAQEAAAAAAAAAAAAAAAAAAQISUf/aAAwDAQACEQMRAD8AjBZYOKuuLaEZCFIHu9bkRENxPBNNH//Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/Take-Course.jpg
/* harmony default export */ var Take_Course = ({"src":"/_next/static/media/Take-Course.4e0a6be1.jpg","height":892,"width":960,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAeEAAABgIDAAAAAAAAAAAAAAAAAQIDBBEFBhIhQf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCmS9eiSs5HySpUtt5ok8UNu0gySd0ZV7fYAAD/2Q==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/images/soc_logo.png
/* harmony default export */ var soc_logo = ({"src":"/_next/static/media/soc_logo.e8282f7c.png","height":100,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABnRSTlMvSjtfFR2eZmx6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHUlEQVR4nAXBAQEAAAzCoE19/8oHrAYG1iTH0TL2AkUAMNT4X/MAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/images/pavol.jpg
/* harmony default export */ var pavol = ({"src":"/_next/static/media/pavol.d58e396c.jpg","height":96,"width":96,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAgEAAABQMFAAAAAAAAAAAAAAAAAQIDEwQFMQYRElGB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/xAAXEQEBAQEAAAAAAAAAAAAAAAABAAIS/9oADAMBAAIRAxEAPwCiprhTL1Ip8nXooCbycfLfrHoAAHAVdLf/2Q==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/theodor.jpg
/* harmony default export */ var theodor = ({"src":"/_next/static/media/theodor.e9968c49.jpg","height":460,"width":460,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAgEAABBAEEAwAAAAAAAAAAAAABAAIDBBEFBhUxISOR/8QAFAEBAAAAAAAAAAAAAAAAAAAAA//EABgRAAMBAQAAAAAAAAAAAAAAAAABAhES/9oADAMBAAIRAxEAPwC28Y9cv07F/iZ3XZHeuNvksi6AwO8A/SUREUytY3dJLD//2Q==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/favicon.ico
/* harmony default export */ var favicon = ({"src":"/_next/static/media/favicon.6cc3dbe0.ico","height":96,"width":96});
;// CONCATENATED MODULE: ./public/images/java_logo.png
/* harmony default export */ var java_logo = ({"src":"/_next/static/media/java_logo.e21faf2b.png","height":100,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEVMaXGNg794X9BwVddxU9WVlrWnqqlwU9enqKpyU9biwAUNAAAACnRSTlMAETwmSR1YWXlqOH100gAAAAlwSFlzAAALEwAACxMBAJqcGAAAADJJREFUeJwlysENADAIAkBUULv/wg3xAxcCAEDhBNSH2L4heq9TqbTmTRlVb8LvJMnCBxARAIs+gxz9AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/database.png
/* harmony default export */ var database = ({"src":"/_next/static/media/database.912a8950.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAS1BMVEUqKgABNlABR2m2ngEBYY0Bics/NgCehwEBWYMAAwoLTmgCYpUCaaB5YwI0LgBObToCTW5nWQCskAABgr4CldaTgQACZp0EfrU9bliyQIYEAAAAEnRSTlMBger9+v44/foc+/7V9lPsbIPzFAPKAAAACXBIWXMAAAOxAAADsQH1g+1JAAAARElEQVR4nB3LQQ6AIAwF0Q8UWgFFaQHvf1KDu8lLBs5n7wCAZplyACimRjtEl/4iMa58pQSy+PYQGHetrfPoe3yYx/kBTK0CX8ThTRcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/webGamesLogo.png
/* harmony default export */ var webGamesLogo = ({"src":"/_next/static/media/webGamesLogo.0d237be9.png","height":124,"width":143,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAVFBMVEVMaXHzeVWTZr3/8ACKRb6RZL/veS//az0zOcBiMvq0hIn/d1WrfpmWarm9qxjZYUq2gXXXvzZpwuhbcJSEyMP34B7eyBTv2heAveRvrND/so3CrxhnCkNYAAAAGnRSTlMAcJUjJ3sQBA0dZh6ql1U3glSKVF6M53b+qcpp/mIAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA8SURBVHicFctJFoAgDMDQIIWCEwo43/+evq7yN4HiIgrg3slHQ9t0DALprjIPIaFPlyVnhevcLXB8q10/MsgBzEh9qFIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/images.tsx















var FirstDesignCourseDetail = Course_Detail;
var Gabriel = gabriel;
var FirstDesignHome = Home;
isielBySomZnovaNaVysoku/* default */.Z;
var Jakub = jakub;
var ProjectMockup = leto_2020_EDITED;
var FirstPodcast = prvy_podcast_scaled;
var FirstDesignTakeCoursePage = Take_Course;
var socLogo = soc_logo;
var socLamp = favicon;
var images_pavol = pavol;
var images_theodor = theodor;
var javaCourseLogo = java_logo;
var sqlLogoImage = database;
var images_webGamesLogo = webGamesLogo;


/***/ }),

/***/ 38434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25925);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81990);
/* harmony import */ var _components_core_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21523);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74399);
/* harmony import */ var _hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99216);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1864);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px;\n\n  svg {\n    width: 18px;\n    height: 18px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var useThemeConfig = function(themeSetting, theme) {
    return ({
        LIGHT: {
            nextThemeSetting: "DARK",
            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_icons_md__WEBPACK_IMPORTED_MODULE_6__/* .MdOutlineLightMode */ .A9M, {})
        },
        DARK: {
            nextThemeSetting: "AUTO",
            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_icons_md__WEBPACK_IMPORTED_MODULE_6__/* .MdOutlineDarkMode */ .UFB, {})
        },
        AUTO: {
            nextThemeSetting: "LIGHT",
            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_icons_md__WEBPACK_IMPORTED_MODULE_6__/* .MdOutlineHdrAuto */ .rpq, {})
        },
        "NOT-SET": {
            nextThemeSetting: theme === _theme__WEBPACK_IMPORTED_MODULE_4__/* .lightTheme */ .W ? "DARK" : "LIGHT",
            icon: theme === _theme__WEBPACK_IMPORTED_MODULE_4__/* .lightTheme */ .W ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_icons_md__WEBPACK_IMPORTED_MODULE_6__/* .MdOutlineLightMode */ .A9M, {}) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_icons_md__WEBPACK_IMPORTED_MODULE_6__/* .MdOutlineDarkMode */ .UFB, {})
        }
    })[themeSetting];
};
var ThemeSwitcher = function(_param) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    var ref = (0,_hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .F)(), theme = ref.theme, themeSetting = ref.themeSetting, setThemeSetting = ref.setThemeSetting;
    var ref1 = useThemeConfig(themeSetting, theme), nextThemeSetting = ref1.nextThemeSetting, icon = ref1.icon;
    var switchTheme = function() {
        setThemeSetting(nextThemeSetting);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        className: className
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledButton, {
            iconBefore: icon,
            onClick: switchTheme
        })
    }));
};
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-cdca4e43-0"
})(_templateObject());
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_components_core_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cdca4e43-1"
})(_templateObject1());
/* harmony default export */ __webpack_exports__["Z"] = (ThemeSwitcher);


/***/ })

}]);